import React, { Component } from 'react';

interface ScreenNameProps {
  screenId: string;
  screenName: string;
}

interface ScreenNameState {
  screenId: string;
  screenName: string;
}

class ScreenName extends Component<ScreenNameProps, ScreenNameState> {
  constructor(props: ScreenNameProps) {
    super(props);
    this.state = {
      screenId: props.screenId,
      screenName: props.screenName,
    };
  }

  render() {
    return (
      <div key={this.state.screenId} className='uc-form-field uc-form-field--horizontal u-float-left u-mb0' data-testid='screenId'>
        <h2 className='headline-3 u-white-space-nowrap' data-testid='screenName' data-testid-e2e='screenName-screenId'>
          {this.state.screenName}
        </h2>
      </div>
    );
  }
}

export default ScreenName;
